import { withOidcSecure } from "@axa-fr/react-oidc";
import React, { useEffect, useState } from "react";
import HomeLayout from "../../../Layout/HomeLayout";
import HomeHeader from "../../../CustomComponents/HomeHeader";
import Loader from "../../../CustomComponents/Loader";
import { useTranslation } from "react-i18next";
import Modal from "../../../CustomComponents/Modal";
import { useDispatch, useSelector } from "react-redux";
import { appTheme } from "../../../../helpers/utils/Utils";
import InstallMentAmount from "./InstallmentAmount";
import AccountName from "./AccountName";
import AllocateDateCard from "./AllocateDateCard";
import AllocateNotificationType from "./AllocateNotificationType";
import AllocateConfirmationCard from "./AllocateConfirmationCard";
import SuccessAllocateModal from "./SuccessAllocateModal";
import { addLineBreaks } from "../../../../utils";
import ErrorAllocateModal from "./ErrorAllocateModal";
import { useNavigate } from "react-router";
import ExistedSavingGoalAlertModal from "../AddSavingGoal/ExistedSavingGoalAlertModal";
import ExistedAllocateSavingGoalModal from "../AddSavingGoal/ExistedAllocateSavingGoalModal";
import InsufficientBalanceModal from "../AddSavingGoal/InsufficientBalanceModal";

const AllocateFund = () => {
  const HeadingStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--head-modal-clr)]";
  const SubHeadingStyles =
    "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal text-[var(--modal-sub-text-clr)] md:w-[80%]";

  const kudzuPlusTrue = useSelector((state) => state.kudzuPlusTrue);
  const errorModal = useSelector((state) => state.errorAllocateModal);
  const responseMsg = useSelector((state) => state.allocateFundResonseMsg);
  const appThemeData = appTheme(kudzuPlusTrue);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [alertCard, setAlertCard] = useState("InstallMentAmount");
  const [spendAlertStatus, setSpendAlertStatus] = useState("");
  const [isSubErrMsg, setIsSubErrMsg] = useState(true);
    const [openExistedErrorModal, setOpenExistedErrorModal] = useState(false);
  let showBalAlert = useSelector(state => state.showBalanceAlert);
  const navigate = useNavigate();
  const cardHeader = () => {
    return (
      <>
        <div
          class=" lg:my-[2rem] md:my-[1.5rem] my-[1.5rem] font-[500]
            lg:text-[26px] md:text-[22px] sm:text-[20px] text-[20px] leading-[36px]
             font-hanken-grotesk sm:mx-0 mx-4"
        >
          {" "}
          {t("Allocate_Funds")}
        </div>
        <div class="border-[#94C3E8] border-b-[3px] sm:mx-0 mx-4"></div>
      </>
    );
  };

  const setAlertCardFun = (value) => {
    setAlertCard(value);
  };
  const setSavingAlertStatusFun = (value) => {
    if (value === "success") {
      openSuccessfullModal();
    } else if (value === 'existedName'){ 
          openExistingNameErrorModal();
    } 
    else {
      openErrorModal();
    }
  };

  const setSpendingAlertErrorFun = (err) => {
    setIsSubErrMsg(false);
  };
  const  closeExistedNameModal = () => {
    setOpenExistedErrorModal(false) 
    navigate("/Climb/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails");
  };

  const closeBalAlertModal = () => {
    dispatch({
      type: "SHOW_BALANCE_ALERT",
      payload: { showBalanceAlert: false }
    })
    navigate("/Climb/SavingGoals/ManageSavingGoal/ManageSavingGoalDetails");
  };

  const handleErrorModalClose = (value) => {
    setOpenExistedErrorModal(value)
    navigate('/Climb/SavingGoals/ManageSavingGoal');
  }
  const openExistingNameErrorModal = () => { 
    setOpenExistedErrorModal(true);
  };

  const cardFooter = (
    handleBackClick,
    handleNextClick,
    button1,
    button2,
    isNextActive = true,
    stylesForFooter
  ) => {
    return (
      <div className={`flex flex-row sm:justify-end justify-between items-center  md:gap-16 sm:gap-10 sm:mx-0 mx-4 lg:pb-[5rem] md:pb-[4rem] sm:pb-[3rem] pb-[3rem] ${stylesForFooter ? stylesForFooter : ""}`}>
        <p
          className="font-hanken-grotesk font-[600] sm:font-[700] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                leading-[26px] sm:leading-[13px]  md:leading-[18px] 
                text-[var(--backdrop-color)] cursor-pointer capitalize"
          onClick={handleBackClick}
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === "Enter") handleBackClick();
          }}
        >
          {button1 || `${t("back")}`}
        </p>
        <div>
          <div className="flex flex-row justify-end  gap-2 cursor-pointer items-center">
            <button
              className={`font-hanken-grotesk font-[600] sm:font-[700] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                         leading-[26px]  sm:leading-[13px] 
                          md:leading-[18px] ${
                            !isNextActive
                              ? "text-[var(--nextdrop-color)] opacity-55"
                              : "text-[var(--nextAct-color)]"
                          } `}
              onClick={handleNextClick}
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleNextClick();
              }}
              disabled={!isNextActive}
            >
              {button2 || `${t("next")}`}
            </button>
            <img
              src={
                !isNextActive
                  ? appThemeData.NextArrowInactive
                  : appThemeData.RightArrowActive
              }
              alt="arrow"
              className="h-[12px] w-[12px] 
                        sm:h-[10px] sm:w-[11px] md:h-[15px] md:w-[17px]"
            />
          </div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    switch (alertCard) {
      case "InstallMentAmount":
        displayAmountCard();
        hideAccountCard();
        hideDateCard();
        hideNotificationTypeCardCard();
        hideConfimationCard();
        break;
      case "AccountName":
        displayAccountCard();
        hideAmountCard();
        hideDateCard();
        hideNotificationTypeCardCard();
        hideConfimationCard();
        break;
      case "AllocateDateCard":
        displayDateCard();
        hideAccountCard();
        hideAmountCard();
        hideNotificationTypeCardCard();
        hideConfimationCard();
        break;
      // case "AllocateNotificationType":
      //   displayNotificationTypeCardCard();
      //   hideDateCard();
      //   hideConfimationCard();
      //   hideAccountCard();
      //   hideAmountCard();
      //   break;
      case "AllocateConfirmationCard":
        displayConfimationCard();
        hideNotificationTypeCardCard();
        hideDateCard();
        hideAccountCard();
        hideAmountCard();
        break;
    }
  }, [alertCard]);

  useEffect(() => {
    switch (spendAlertStatus) {
      case "success":
        openSuccessfullModal();
        break;
      case "error":
        openErrorModal();
        break;
      case "existedName":
        openExistingNameErrorModal();
        break;
    }
  }, [spendAlertStatus]);

  // DISPLAY CARDS--------

  //Amount card
  const [isAmountCard, setIsAmountCard] = useState(false);

  const displayAmountCard = () => {
    setIsAmountCard(true);
  };

  const hideAmountCard = () => {
    setIsAmountCard(false);
  };

  //TimeFrame card
  const [isAccountName, setIsAccountName] = useState(false);

  const displayAccountCard = () => {
    setIsAccountName(true);
  };

  const hideAccountCard = () => {
    setIsAccountName(false);
  };

  //Date card
  const [isDateCard, setIsDateCard] = useState(false);

  const displayDateCard = () => {
    setIsDateCard(true);
  };

  const hideDateCard = () => {
    setIsDateCard(false);
  };

  //Notification Type card
  const [isNotificationTypeCard, setIsNotificationTypeCard] = useState(false);

  const displayNotificationTypeCardCard = () => {
    setIsNotificationTypeCard(true);
  };

  const hideNotificationTypeCardCard = () => {
    setIsNotificationTypeCard(false);
  };

  //Confimation card
  const [isConfimationCard, setIsConfimationCard] = useState(false);

  const displayConfimationCard = () => {
    setIsConfimationCard(true);
  };

  const hideConfimationCard = () => {
    setIsConfimationCard(false);
  };

  // Successfull transfer modal
  const succesModalAllocate = useSelector(
    (state) => state.succesModalAllocateFund
  );

  const openSuccessfullModal = () => {
    dispatch({
      type: "SUCCESS_MODAL_ALLOCAT_FUND",
      payload: { succesModalAllocateFund: true },
    });
  };

  const closeSuccessfullModal = () => {
    dispatch({
      type: "SUCCESS_MODAL_ALLOCAT_FUND",
      payload: { succesModalAllocateFund: false },
    });
    navigate("/Climb/SavingGoals/ManageSavingGoal");
    dispatch({ type: "RESET_ALLOCATE_FUND" });
    dispatch({ type: "RESET_SAVING_GOALS" });
  };

  // Error modal
  const openErrorModal = () => {
    dispatch({
      type: "ERROR_ALLOCATE_MODAL",
      payload: { errorAllocateModal: true },
    });
  };

  const closeErrorModal = () => {
    dispatch({
      type: "ERROR_ALLOCATE_MODAL",
      payload: { errorAllocateModal: false },
    });
    dispatch({ type: "RESET_ALLOCATE_FUND" });
    dispatch({ type: "RESET_SAVING_GOALS" });
    navigate("/Climb/SavingGoals");
  };

 

  return (
    <HomeLayout>
      <HomeHeader
        heading={addLineBreaks(t("Add_Some_Funds_To_Work"))}
        isHeaderCaption={true}
      />

      <div
        className="flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%] 
            animate__animated animate__fadeInRight "
      >
        {isAmountCard && (
          <InstallMentAmount
            cardHeader={cardHeader()}
            cardFooter={cardFooter}
            onBack={setAlertCardFun}
            onNext={setAlertCardFun}
          />
        )}
        {isAccountName && (
          <AccountName
            cardHeader={cardHeader()}
            cardFooter={cardFooter}
            onBack={setAlertCardFun}
            onNext={setAlertCardFun}
          />
        )}
        {isDateCard && (
          <AllocateDateCard
            cardHeader={cardHeader()}
            cardFooter={cardFooter}
            onBack={setAlertCardFun}
            onNext={setAlertCardFun}
          />
        )}
        {isConfimationCard && (
          <AllocateConfirmationCard
            cardHeader={cardHeader()}
            cardFooter={cardFooter}
            onBack={setAlertCardFun}
            onEdit={setAlertCardFun}
            onSave={setSavingAlertStatusFun}
            onSetSpendSenseAlertFun={setSpendingAlertErrorFun}
          />
        )}
      </div>

      <Modal
        isOpen={succesModalAllocate}
        onClose={closeSuccessfullModal}
        alignItems={"items-center"}
        isClimbg={true}
        subtitle={
          <p>
            <span className={SubHeadingStyles}>
              <span className={`${HeadingStyles}`}>{t("success")} </span>
              {t("Your_Saving_Goal_Set")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            <SuccessAllocateModal />
          </div>
        }
      />

      <Modal
        isOpen={openExistedErrorModal}
        onClose={closeExistedNameModal}
        alignItems={"items-center"}
        isClimbg={true}
        //   title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('success')}</p>}
        subtitle={
          <p>
            <span className={SubHeadingStyles}>
              <span className={`${HeadingStyles}`}>
                {t("oops_exclamation")}{" "}
              </span>
              {t("plz_try_again")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            <ExistedAllocateSavingGoalModal
              modalClose={handleErrorModalClose}
            />
          </div>
        }
      />

<Modal
        isOpen={showBalAlert}
        onClose={closeBalAlertModal}
        alignItems={"items-center"}
        isClimbg={true}
        //   title={<p className={`${HeadingStyles} hidden sm:flex`}>{t('success')}</p>}
        subtitle={
          <p>
            <span className={SubHeadingStyles}>
              <span className={`${HeadingStyles}`}>
                {t("oops_exclamation")}{" "}
              </span>
              {t("Not_have_funds")}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            <InsufficientBalanceModal
              modalClose={handleErrorModalClose}
            />
          </div>
        }
      />

      <Modal
        isOpen={errorModal}
        onClose={closeErrorModal}
        alignItems={"items-center"}
        isClimbg={true}
        subtitle={
          <p>
            {/* <span className={SubHeadingStyles}><span className={`${HeadingStyles}`}>{t('oops_exclamation')} </span>{addLineBreaks(t('AllocateErrorMsg'))}</span> */}
            <span className={SubHeadingStyles}>
              <span className={`${HeadingStyles}`}>
                {t("oops_exclamation")}{" "}
              </span>
              {responseMsg}
            </span>
          </p>
        }
        content={
          <div class="aspect-454/253 md:mt-10 sm:mt-6 mt-6">
            <ErrorAllocateModal
              onBack={setAlertCardFun}
              isSubErrMsg={t("Please_Try_Again")}
            />
          </div>
        }
      />

      {isLoading && <Loader />}
    </HomeLayout>
  );
};

export default withOidcSecure(AllocateFund);
